import { render, staticRenderFns } from "./FormCallBack.vue?vue&type=template&id=22b85cf5"
import script from "./FormCallBack.vue?vue&type=script&lang=js"
export * from "./FormCallBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports